/* eslint-disable */
function sortArray( array ) {
	for ( const key in array ) {
		array[key].sort();
	}

	return array;
}

function filterCount( query ) {
	let count = 0;

	for ( const key in query ) {

		// Don't add to query if empty
		if ( 0 !== query[ key ].length ) {

			for ( const tag in query[ key ] ) {
				count++;
			}
		}

	}

	let radios = document.getElementsByName( 'sort' );

	for ( let i = 0, length = radios.length; i < length; i++ ) {

		if ( radios[i].checked ) {

			if ( 'DESC' != radios[i].value ) {
				count++;
			}

			// only one radio can be logically checked, don't check the rest
			break;
		}
	}

	jQuery( '.c-archive-filter__filter-number' ).html( count );
}

function buildQuery( query ) {
	let returnQuery = '';

	for ( const key in query ) {

		// Don't add to query if empty
		if ( 0 !== query[ key ].length ) {
			returnQuery += '&' + key + '=' + query[ key ];
		}

	}

	let radios = document.getElementsByName( 'sort' );

	for ( let i = 0, length = radios.length; i < length; i++ ) {

		if ( radios[i].checked ) {

			// Add query if not standard sorting
			if ( 'DESC' != radios[i].value ) {
				returnQuery += '&order=' + radios[i].value;
			}

			// only one radio can be logically checked, don't check the rest
			break;
		}
	}

	return returnQuery;
}

function showFilterButton( button ) {
	button.removeAttribute( 'disabled' );
}

function hideFilterButton( button ) {
	button.setAttribute( 'disabled', '' );
}

function returnActivePills( items ) {
	let append = '';

	for ( const item in items ) {

		if ( 0 !== items[ item ].length ) {

			for ( const tag in items[ item ] ) {

				// Get the name from active input
				const name = jQuery( '.c-archive-filter__tags input[ data-tax-name="' + item + '" ][ value="' + items[ item ][ tag ] + '" ]' ).siblings( 'span' ).text();

				append += '<button class="c-filter-pill" data-tax-name="' + item + '" data-tag-slug="' + items[ item ][ tag ] + '">' + name + '<span class="c-close-icon"></span></button>';

			}

		}

	}

	return append;
}

function bindRemovalPills() {
	const $pills = jQuery( '.c-archive-filter__active-filters button' );

	$pills.on( 'click', function() {
		let currentTax = this.dataset.taxName;
		let tagName    = this.dataset.tagSlug;
		jQuery( '.c-archive-filter__tags input[ data-tax-name="' + currentTax + '" ][ value="' + tagName + '" ]' ).removeAttr( 'checked' ).change();
	});
}

function filterDisplayLogic( activeQuery, selectedFilter, applyButton ) {
	// Sort selected filter
	selectedFilter = sortArray( selectedFilter );

	// Build selected query string from array
	let selectedQuery = buildQuery( selectedFilter );

	// Add query to button
	jQuery( applyButton ).attr( "href", applyButton.dataset.currentUrl + '?' + buildQuery( selectedFilter ) );

	// Remove current pills and add the new ones
	jQuery( '.c-archive-filter__active-filters button' ).remove();
	jQuery( '.c-archive-filter__active-filters' ).prepend( returnActivePills( selectedFilter ) );

	// Bind removal events to pills
	bindRemovalPills();

	// Show/hide apply button if strings are not the same
	if ( selectedQuery === activeQuery ) {
		hideFilterButton( applyButton );
		jQuery( '#collapseApplyButton' ).collapse( 'hide' );
	} else {
		showFilterButton( applyButton );
		jQuery( '#collapseApplyButton' ).collapse( 'show' );
	}

	// Hide pills if selected query is empty
	if ( '' === selectedQuery ) {
		jQuery( '#collapseActiveFilters' ).collapse( 'hide' );
	} else {
		jQuery( '#collapseActiveFilters' ).collapse( 'show' );
	}
}

jQuery( function( $ ) {

	// Check if filter exists
	if ( 0 < $( '.c-archive-filter' ).length ) {

		// Setup filter variables
		let activeFilter   = [];
		let selectedFilter = [];
		const applyButton  = document.getElementById( 'applyFilter' );
		const $inputs      = $( '.c-archive-filter__tags input' );
		const $sort        = $( '.c-archive-filter__sort input' );

		// Get active filter on load
		$inputs.each( function () {

			let currentTax = this.dataset.taxName;

			if ( this.checked ) {

				// Add key to arrays if it doesn't exist
				if ( ( false === [ currentTax ] in activeFilter ) ) {
					activeFilter[ currentTax ]   = [];
					selectedFilter[ currentTax ] = [];
				}

				// Add term to arrays grouped by taxonomy
				activeFilter[ currentTax ].push( this.value );
				selectedFilter[ currentTax ].push( this.value );

			}

		});

		// Add active pills to elemnt
		$( '.c-archive-filter__active-filters' ).prepend( returnActivePills( activeFilter ) );

		// Bind removal event to pills
		bindRemovalPills();

		// Setup active filter on load for reference later
		let activeQuery = buildQuery( activeFilter );
		activeFilter    = sortArray( activeFilter );

		// Add filter count to element
		filterCount( activeFilter );

		// Show/Hide the filters on load
		filterDisplayLogic( activeQuery, selectedFilter, applyButton );

		$( applyButton ).attr( 'href', applyButton.dataset.currentUrl + '?' + activeQuery );

		// Update selectedFilter on change
		$inputs.change( function () {

			let currentTax = this.dataset.taxName;

			if ( this.checked ) {
				// Add key to array if it doesn't exist
				if ( ( false === [ currentTax ] in selectedFilter ) ) {
					selectedFilter[ currentTax ] = [];
				}

				// Add term to array grouped by taxonomy
				selectedFilter[ currentTax ].push( this.value );

			} else {
				// Remove term from array
				selectedFilter[ currentTax ].splice( selectedFilter[ currentTax ].indexOf( this.value ), 1 );
			}

			// Show/Hide the filters
			filterDisplayLogic( activeQuery, selectedFilter, applyButton );

		});

		// Update selectedFilter on change
		$sort.change( function () {
			// Show/Hide the filters
			filterDisplayLogic( activeQuery, selectedFilter, applyButton );
		});

	}
});
